export default "__VITE_ASSET__mnzR5$t92TjXQ_O9LAMEfg__"